<template>
  <v-card class="back" style="height: 800px">
    <v-layout fill-height>
      <v-flex >
        <v-layout column fill-height>
          <scroll-area>
            <template slot="header">
              <v-toolbar dark color="secondary" dense flat>
                <v-toolbar-title>
                  <span class="body-2 text-uppercase">{{ getFields.template || '' }}</span>
                </v-toolbar-title>

                <v-layout  justify-end>
                <v-tooltip dark color="secondary" bottom>
                  <v-btn icon flat slot="activator" 
                  :data-testid="$options.name + '__btn__' + 'close'"
                  @click="()=>{$emit('close')}">
                    <svg-icon
                      :color="'white'"
                      :name="'close'"
                      width="20"
                    />
                  </v-btn>
                  <span>{{ $t('close') }}</span>
                </v-tooltip>
              </v-layout>

              </v-toolbar>             
            </template>

            <template slot="body">
              <v-layout fill-height justify-start class="pa-2">
                <v-layout column fill-height justify-start >

                  <v-layout shrink v-for="(field, index) in Object.keys(getFields) " :key="index" >

                    <v-flex xs4 shrink px-0 pb-2>
                      <v-text-field
                        :value="$t(field)"
                        light
                        auto-grow
                        single-line
                        flat
                        readonly
                        disabled
                        class="white"
                        persistent-hint
                        hide-details                    
                        :rows="1"
                        color="grey"
                      >
                      </v-text-field>
                    </v-flex>
                    
                    <v-flex xs8 shrink px-0 pb-2>
                      <v-text-field
                        v-if="field.type == 'integer'"
                        v-model.number="model.obj[field]"
                        :type="'number'"
                        light
                        auto-grow
                        single-line
                        flat
                        readonly
                        class="white"
                        persistent-hint
                        hide-details                     
                        :rows="1"
                        color="accent"
                      >
                      </v-text-field>
                      <v-text-field
                        v-else
                        v-model="model.obj[field]"
                        light
                        auto-grow  
                        single-line
                        flat
                        readonly
                        class="white"
                        persistent-hint
                        hide-details                     
                        :rows="1"
                        color="accent"
                      >
                      </v-text-field>

                    </v-flex>

                  </v-layout>

                </v-layout>

                <v-flex xs6 v-if="getData.pattern" justify-start style="position: relative">
                  <v-layout column fill-height justify-start >
                    <v-layout shrink style="height: 48px" class="body-2 accent" align-center pl-3>
                      {{ getFields.template || '' }}
                      <v-layout v-if="cmOptions.readOnly"  justify-end>
                        <v-tooltip dark color="secondary" bottom>
                          <v-btn icon flat slot="activator" 
                          :data-testid="$options.name + '__btn__' + 'edit'"
                          @click="cmOptions.readOnly = false">
                            <svg-icon
                              :color="'white'"
                              :name="'edit'"
                              width="20"
                            />
                          </v-btn>
                          <span>{{ $t('edit') }}</span>
                        </v-tooltip>
                      </v-layout>
                    </v-layout>                
                    <v-layout column fill-height >
                        <codemirror v-model="model.pattern" :options="cmOptions"></codemirror>
                    </v-layout>
                  </v-layout>
                </v-flex>
              </v-layout>
            </template>

            <template slot="footer">
              <v-layout fill-height>
                <v-layout fill-height justify-start>
                  <v-btn v-if="!cmOptions.readOnly" dark small :data-testid="$options.name + '__btn__' + 'saveData'" @click="()=>saveData()" color="success">{{$t('save')}}</v-btn>
                </v-layout>
                <v-layout fill-height justify-end>
                  <v-btn dark small :data-testid="$options.name + '__btn__' + 'footer_close'" @click="()=>{$emit('close')}" color="grey">{{$t('close')}}</v-btn>                 
                </v-layout>
              </v-layout>
            </template>

          </scroll-area>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/addon/merge/merge.js'
import 'codemirror/addon/merge/merge.css'
import 'codemirror/theme/base16-dark.css'
import 'codemirror/mode/vue/vue.js'
import 'codemirror/addon/selection/active-line.js'
import 'codemirror/addon/selection/mark-selection.js'
import 'codemirror/addon/search/searchcursor.js'
import 'codemirror/addon/scroll/annotatescrollbar.js'
import 'codemirror/addon/search/matchesonscrollbar.js'
import 'codemirror/addon/search/match-highlighter.js'
import 'codemirror/mode/clike/clike.js'
import 'codemirror/addon/edit/matchbrackets.js'
import 'codemirror/addon/comment/comment.js'
import 'codemirror/addon/dialog/dialog.js'
import 'codemirror/addon/dialog/dialog.css'
import 'codemirror/addon/search/search.js'
import 'codemirror/keymap/sublime.js'
import 'codemirror/addon/fold/foldgutter.css'
import 'codemirror/addon/fold/brace-fold.js'
import 'codemirror/addon/fold/comment-fold.js'
import 'codemirror/addon/fold/foldcode.js'
import 'codemirror/addon/fold/foldgutter.js'
import 'codemirror/addon/fold/indent-fold.js'
import 'codemirror/addon/fold/markdown-fold.js'
import 'codemirror/addon/fold/xml-fold.js'
import DiffMatchPatch from 'diff-match-patch'

// Типы
interface CmOptions {
  tabSize: number
  styleActiveLine: boolean
  lineNumbers: boolean
  line: boolean
  foldGutter: boolean
  styleSelectedText: boolean
  mode: string
  keyMap: string
  matchBrackets: boolean
  showCursorWhenSelecting: boolean
  theme: string
  extraKeys: { [key: string]: string }
  hintOptions: { completeSingle: boolean }
  readOnly: boolean
}

interface ModelData {
  fields: Record<string, any>
  obj: Record<string, any>
  pattern: string | null
}

interface TemplateData {
  template?: Record<string, any>
  pattern?: string
  [key: string]: any
}

interface UpdateData {
  template?: string
  pattern?: string
  [key: string]: any
}

// DiffMatchPatch config with global
;(window as any).diff_match_patch = DiffMatchPatch
;(window as any).DIFF_DELETE = -1
;(window as any).DIFF_INSERT = 1
;(window as any).DIFF_EQUAL = 0

export default Vue.extend({
  name: 'ZTP_TEMPLATES_CARD',

  components: {
    scrollArea,
    svgIcon,
    codemirror,
  },

  props: {
    data: {
      type: Object as () => TemplateData,
      default: () => ({})
    },
  },

  data(): {
    model: ModelData
    cmOptions: CmOptions
  } {
    return {
      model: {
        fields: {},
        obj: {},
        pattern: null,
      },
      cmOptions: {
        tabSize: 4,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        foldGutter: true,
        styleSelectedText: true,
        mode: 'text/javascript',
        keyMap: 'sublime',
        matchBrackets: true,
        showCursorWhenSelecting: true,
        theme: 'monokai',
        extraKeys: { Ctrl: 'autocomplete' },
        hintOptions: { completeSingle: false },
        readOnly: true
      },
    }
  },

  computed: {
    getData(): TemplateData {
      return this.data
    },
    getFields(): Record<string, any> {
      return this.model.fields
    },
  },

  watch: {
    data: {
      handler(newVal: TemplateData): void {
        if (newVal) {
          this.setup()
        }
      },
      deep: true
    },
  },

  created(): void {
    console.log(this.$options.name, 'DATA', this.getData)
    this.setup()
  },

  methods: {
    setup(): void {
      this.reset()
      if (this.getData.template) {
        this.prepareData()
      }
    },

    reset(): void {
      this.model = {
        fields: {},
        obj: {},
        pattern: null,
      }
      this.cmOptions = {
        tabSize: 4,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        foldGutter: true,
        styleSelectedText: true,
        mode: 'text/javascript',
        keyMap: 'sublime',
        matchBrackets: true,
        showCursorWhenSelecting: true,
        theme: 'monokai',
        extraKeys: { Ctrl: 'autocomplete' },
        hintOptions: { completeSingle: false },
        readOnly: true
      }
    },

    prepareData(): void {
      this.$set(this.model, 'fields', {})
      this.$set(this.model, 'obj', {})
      this.$set(this.model, 'pattern', null)

      if (this.getData.template) {
        Object.keys(this.getData.template).forEach(key => {
          this.$set(this.model.fields, key, this.getData.template![key])
          this.$set(this.model.obj, key, this.getData.template![key])
        })
      }
      if (this.getData.pattern) {
        this.$set(this.model, 'pattern', this.getData.pattern)
      }
    },

    async saveData(): Promise<void> {
      try {
        this.$dialog.confirm({
          text: 'Сохранить изменения?',
          title: 'Сохранение',
          actions: {
            false: 'Отмена',
            true: {
              color: 'green',
              text: 'Сохранить',
              handle: () => {
                console.log(this.$options.name, 'saveData', this.model.obj)
                this.$emit('update', {
                  template: this.model.obj.template,
                  pattern: this.model.pattern
                } as UpdateData)
                this.$emit('close')
              }
            }
          }
        })
      } catch (err) {
        this.$errorHandler(err)
      }
    },
  },
})
</script>

<style lang="css" scoped>

  .CodeMirror cm-s-monokai {
    height: 100% !important;
    min-height: 100% !important;
    position: absolute !important;
  }

  .vue-codemirror {
    height: 100%;
    width: 100%;
    position: relative;
  }

  .customToolbar {
    background-color: #58595B;
    height: 48px;
    font-size: 20px;
    font-weight: 500;
  }

</style>

<style lang="stylus" scoped>
.rule
  border 1px solid #c1c163
  margin-bottom: 5px;
  padding: 5px;
.rule-item
  //border 1px solid red
  display flex
  justify-content stretch
  align-items baseline
  .field
    margin 0 3px
    outline: darkgray solid 1px;
    height: 30px;
    padding-left: 5px;
    line-height: 30px;
    background-color: white;
.v-btn.supersmall
  padding-top: 4px
  height: 24px
  width: 24px
  right: 5px
</style>
